<template>
    <div class="fb_post">

        <header class="fb_post-header">
            <a :href="post.link">
                <img :src="post.caption.from.profile_picture"
                     alt="" width="50" height="50"></a>
            <span class="page_title">{{ post.caption.from.full_name }}</span>
            <span class="fb_post-created">{{ post.caption.created_time | toMiliSeconds |
                                                          dateFormat( 'd.F Y' )
                                                          }}</span>
        </header>

        <div class="fb_post-content" v-show="post.caption.text">
            <p v-html="post.caption.text"></p>
        </div>

        <template v-if="post.type == 'image'">
            <a :href="post.link" target="_blank">
                <img :src="post.images.standard_resolution.url" alt="">
            </a>
        </template>
        <template v-else-if="post.type == 'carousel'">
            <div class="fb_post-gallery" >
                <img v-for="(img, idx) in post.carousel_media" :src="img.images.standard_resolution.url"
                     :width="img.images.standard_resolution.width" :height="img.images.standard_resolution.height"
                     alt="" :key="idx">
            </div>
        </template>
    </div>
</template>

<script>
	export default {
		name: "Post",
		data() {
			return {};
		},
		props: [
			'post'
		],
		methods: {}
	};
</script>

<style scoped>
    .fb_post-gallery img:first-child{
        flex-basis: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/plugins/Instagram/Post.vue